import React, { useEffect, createElement } from 'react';
import { StickyAlertBar } from './components/StickyAlertBar';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { BodyAsking } from './components/BodyAsking';
import { PainPoints } from './components/PainPoints';
import { SalesLetter } from './components/SalesLetter';
import { ProductIntro } from './components/ProductIntro';
import { PricingOffer } from './components/PricingOffer';
import { BenefitsSection } from './components/BenefitsSection';
import { HandbookContents } from './components/HandbookContents';
import { BonusSection } from './components/BonusSection';
import { ValueStack } from './components/ValueStack';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // UTMify Pixel
    ;
    (window as any).pixelId = '69b07faf75d98d5be29863ce';
    const a = document.createElement('script');
    a.setAttribute('async', '');
    a.setAttribute('defer', '');
    a.setAttribute('src', 'https://cdn.utmify.com.br/scripts/pixel/pixel.js');
    document.head.appendChild(a);
    // Track AddToCart on any link click to the cart URL
    const handler = (e: MouseEvent) => {
      const link = (e.target as HTMLElement).closest('a');
      if (link && link.href && link.href.includes('instanthandbook.com/en/cart/add')) {
        try {
          ;
          (window as any).Utmify?.track('AddToCart');
        } catch (err) {}
      }
    };
    document.addEventListener('click', handler, true);
    return () => document.removeEventListener('click', handler, true);
  }, []);
  return <div className="min-h-screen bg-cream font-body" data-id="element-0">
      <StickyAlertBar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <StatsBar data-id="element-3" />
      <BodyAsking data-id="element-4" />
      <PainPoints data-id="element-5" />
      <SalesLetter data-id="element-6" />
      <ProductIntro data-id="element-7" />
      <PricingOffer data-id="element-8" />
      <BenefitsSection data-id="element-9" />
      <HandbookContents data-id="element-10" />
      <BonusSection data-id="element-11" />
      <ValueStack data-id="element-12" />
      <Testimonials data-id="element-13" />
      <Guarantee data-id="element-14" />
      <FAQ data-id="element-15" />
      <FinalCTA data-id="element-16" />
      <Footer data-id="element-17" />
    </div>;
}